import React, { useRef } from 'react';
import { Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import { Button, TextField } from "@curves/ui-base";
import GradientColorHeader from '@icoach/components/dialog/GradientColorHeader';
import useSmsTemplateApi from '@apis/useSmsTemplateApi';

const SmsTemplateEditDialog = React.forwardRef((props, ref) => {
    const { open, onClose: propsOnClose, rowData, onRefrash } = props;
    const { putSmsTemplatePublicDataApi } = useSmsTemplateApi();
    const { name: title, templateText, smsTemplateID } = rowData;
    const titleRef = useRef(null);
    const templateTextRef = useRef(null);

    // 送出 按鈕
    const handleEditClick = () => {
        const params = {
            name: titleRef.current.getResult(),
            templateText: templateTextRef.current.getResult(),
        };
        doEditSMSTemplate(smsTemplateID, params);
    };

    // 編輯 SMS公版 API
    const doEditSMSTemplate = async (smsTmpID, params) => {
        const resp = await putSmsTemplatePublicDataApi(smsTmpID, params);
        if (resp) {
            propsOnClose && propsOnClose();
            onRefrash && onRefrash();
        }
    };

    return (
        <Dialog open={open} PaperProps={{ className: 'wx-65rem' }} fullWidth>
            <GradientColorHeader onClose={propsOnClose}>SMS編輯</GradientColorHeader>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            ref={titleRef}
                            label="簡訊標題"
                            defaultValue={title}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            ref={templateTextRef}
                            label="簡訊內容"
                            defaultValue={templateText}
                            rows={6}
                            multiline
                            fullWidth
                            required
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleEditClick}>
                    送出
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default SmsTemplateEditDialog;
